import React, { FC } from 'react';

import { Box, Skeleton, Typography, useTheme } from '@mui/material';

import { styles } from './styles';
import { IStoryPrompt } from '@bus/storyTeller/typedefs';
import { getDateTime } from '@helpers/getDateTime';
import { useSelector } from 'react-redux';
import { getProgress } from '@bus/storyTeller/selectors';
import StoryImagesList from '@components/pages/private/StoryTellerPage/StoryImagesList';
import FeatureStoryteller from '@components/icons/FeatureStoryteller';

type StoryItemProps = {
  story: IStoryPrompt;
  index: number;
  messageId: number;
  ratio: string;
  chatId: number;
  regenerateLimit: number;
};

export const StoryItem: FC<StoryItemProps> = ({
  story,
  index,
  messageId,
  ratio,
  chatId,
  regenerateLimit,
}) => {
  const theme = useTheme();
  const progress = useSelector(getProgress(chatId));

  return (
    <Box sx={styles.storyItem}>
      <Box sx={styles.messageItemHeader} mb={'20px'}>
        <Box display={'flex'} alignItems={'center'} gap={'10px'}>
          <Box sx={styles.logo}>
            <FeatureStoryteller
              sx={{ fontSize: '32px' }}
              htmlColor={theme.palette.common.surface['surface 46']}
            />
          </Box>
          {story.created_at ? (
            <Typography variant={'body1'} color={'text.secondary'}>
              {getDateTime(story.created_at, 'HH:mm a')}
            </Typography>
          ) : (
            <Skeleton
              variant={'text'}
              sx={{
                fontSize: '14px',
                width: '70px',
                lineHeight: '1.9',
              }}
            />
          )}
        </Box>
      </Box>
      {story.prompt ? (
        <Box display={'flex'} alignItems={'baseline'}>
          <Typography variant={'body1'} color={'text.secondary'} mr={'8px'}>
            {index + 1}.
          </Typography>
          <Typography variant={'body1'} color={'text.secondary'}>
            {story.prompt}
          </Typography>
        </Box>
      ) : (
        <>
          <Skeleton
            variant={'text'}
            sx={{
              fontSize: '14px',
              width: '100%',
              height: '100px',
              lineHeight: '1',
              transform: 'scale(1)',
            }}
          />
          <Skeleton
            variant={'text'}
            sx={{
              mt: '20px',
              fontSize: '14px',
              width: '100%',
              height: '100px',
              lineHeight: '1',
              transform: 'scale(1)',
            }}
          />
        </>
      )}
      {!story.isSkeleton && (
        <Box pt={'20px'}>
          <StoryImagesList
            messageId={messageId}
            progressId={progress?.id}
            images={story.images}
            promptId={story.id}
            ratio={ratio}
            chatId={chatId}
            regenerateLimit={regenerateLimit}
          />
        </Box>
      )}
    </Box>
  );
};

export default StoryItem;
